export const FEATURE_FLAGS = {
  AI_DETECT: 'ai-detect',
  MULTIPLE_TEMPLATES: 'multiple-templates',
  NEW_PRICING: 'new_pricing',
  CONNECT_BOARD: 'connect-board',
  WORD_EDITOR_TOUR: 'word-editor-tour',
  DOCUGEN_CONVERSION: 'docugen-conversion',
};

type FeatureFlagKeys = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

const GLOBALLY_ENABLED_FEATURES: Record<string, boolean> = {
  [FEATURE_FLAGS.AI_DETECT]: true,
  [FEATURE_FLAGS.MULTIPLE_TEMPLATES]: true,
  [FEATURE_FLAGS.NEW_PRICING]: true,
  [FEATURE_FLAGS.CONNECT_BOARD]: true,
  [FEATURE_FLAGS.DOCUGEN_CONVERSION]: false,
  // Tour currently shows for everyone. Flip to `false` (and use
  // FEATURE_ENABLED_ACCOUNTS below) to gate it to specific accounts.
  [FEATURE_FLAGS.WORD_EDITOR_TOUR]: false,
};

/** AI detect is enabled only for these account IDs. */
const FEATURE_ENABLED_ACCOUNTS: Record<string, number[]> = {
  [FEATURE_FLAGS.AI_DETECT]: [],
  [FEATURE_FLAGS.NEW_PRICING]: [],
  [FEATURE_FLAGS.CONNECT_BOARD]: [],
  [FEATURE_FLAGS.WORD_EDITOR_TOUR]: [],
  [FEATURE_FLAGS.DOCUGEN_CONVERSION]: [6282335, 12636756],
};

export const isFeatureEnabled = (
  feature: FeatureFlagKeys,
  accountId?: string | number,
) => {
  if (!(feature in FEATURE_ENABLED_ACCOUNTS)) {
    return false;
  }

  if (GLOBALLY_ENABLED_FEATURES[feature] === true) {
    return true;
  }

  if (!accountId) {
    return false;
  }

  return FEATURE_ENABLED_ACCOUNTS[feature]?.includes(Number(accountId));
};
